module.exports = __webpack_public_path__ + "img/book2.126702a0.png";